// components/ApiStatus.jsx
import React from 'react';
import '../../styles/ApiStatus.css';

export const ApiStatus = ({ apiStatus }) => {
  const endpoints = [
    { key: '/rms/risk/check', name: 'Risk Check', method: 'POST' },
    { key: '/rms/portfolio/analyze', name: 'Portfolio Analyze', method: 'GET' },
    { key: '/rms/position/size', name: 'Position Size', method: 'POST' },
    { key: '/rms/risk/var', name: 'Value at Risk', method: 'GET' },
    { key: '/rms/risk/trailing-stop', name: 'Trailing Stop', method: 'GET' },
    { key: '/rms/risk/settings', name: 'Risk Settings', method: 'PUT' }
  ];

  return (
    <div className="api-status">
      <h3>API Status</h3>
      <div className="status-grid">
        {endpoints.map(endpoint => {
          const status = apiStatus[endpoint.key];
          return (
            <div key={endpoint.key} className="status-card">
              <div className="status-header">
                <span className={`method ${endpoint.method.toLowerCase()}`}>
                  {endpoint.method}
                </span>
                <span className={`status-indicator ${status ? 'success' : 'idle'}`}>
                  {status ? '✓' : '○'}
                </span>
              </div>
              <div className="status-body">
                <h4>{endpoint.name}</h4>
                {status ? (
                  <div className="status-details">
                    <span className="last-called">Last called: {status.lastCalled}</span>
                    <span className="status-badge success">Success</span>
                  </div>
                ) : (
                  <div className="status-details">
                    <span className="last-called">Not called yet</span>
                    <span className="status-badge idle">Idle</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};